import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import styled, { css } from 'styled-components';
import { PrismicRichText, PrismicText } from '@prismicio/react';
import * as prismicHelpers from '@prismicio/helpers';
import { Form, Formik } from 'formik';
import HTTPMethod from 'http-method-enum';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Spacer } from '@yoweb/ui/components/Spacer';
import { TabVertical, TabVerticalContainer } from '@yoweb/ui/components/Tabs';
import { Button } from '@yoweb/ui/components/buttons';
import { Title, Label, Text } from '@yoweb/ui/components/typography';
import { media, gridBase, pxToRem, breakpoints } from '@yoweb/ui/styles/utils';
import { th } from '@yoweb/ui/styles/utils/theme';
import { Accordion } from '@yoweb/ui/components/marketing/Accordion';
import { Container } from '@yoweb/ui/components/containers';
import { htmlSerializerFaqPage } from '@yoweb/ui/utils/prismic';
import { useError, ErrorDisplay, Select, Input, Textarea } from '@yoweb/ui/components/form';
import form, { getTopicsOptions } from '@store/components/Faq/form';
import { withPageTitle } from '@store/components/withPageTitle';
import { SEO } from '@store/components/SEO';
import { useYoForm } from '@yoweb/ui/hooks/forms';
import { fetchJson } from '@yoweb/utils/fetchJson';
import useReCaptcha from '@store/hooks/useReCaptcha';
import { API_FAQ_QUESTION_FORM_SUBMISSION, PAGE_FAQ } from '@store/constants/routes';
import { ACTION_FAQ_QUESTION_FORM_SUBMISSION } from '@store/constants/recaptcha';
import NameGrid from '@yoweb/ui/components/NameGrid';
import HeroImage from '@store/public/images/faq-daytime-cloudy.png';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { replaceUrlsInPrismicContent } from '@yoweb/prismic-slicemachine/utils/contentUtil';
import { getCachedPrismicDomainMapping } from '@yoweb/prismic-slicemachine/constants/config';
import { Grid } from '@yoweb/ui/components/Grid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var __N_SSP = true;
var IDS = {
  faqMenu: 'faq-section-menu',
  faqSectionDesktop: 'faq-section-desktop',
  faqSectionMobile: 'faq-section-mobile',
  submit: 'faq-question-submit',
  form: 'faq-question-form',
  error: 'faq-question-error',
  success: 'faq-question-success'
};
var SCROLL_DELAY_MS = 400;
var fieldSetRowGapWidth = pxToRem(18);
/**
 * The FAQ page.
 * Contains questions and answered sourced from the CMS, and a contact form for additional support.
 */

var Faq = function Faq(_ref) {
  var prismicData = _ref.prismicData;

  var _useTranslation = useTranslation(['common', 'faq']),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useExternalConfig = useExternalConfig(),
      baseUrl = _useExternalConfig.baseUrl;

  var _useRouter = useRouter(),
      query = _useRouter.query;

  var internalURLs = ["".concat(baseUrl).concat(PAGE_FAQ)];
  var _ref2 = query,
      querySection = _ref2.section,
      queryQuestion = _ref2.question; // --- Question form related

  var yoForm = useYoForm('common', form);
  var reCaptcha = useReCaptcha();
  var errorDisplay = useError();

  var _useState = useState(false),
      success = _useState[0],
      setSuccess = _useState[1];

  var options = getTopicsOptions(t);
  var showError = Boolean(errorDisplay.message);
  var config = useExternalConfig();
  var faq_group_slice_type = 'faq_group_slice'; // --- FAQ related

  var faqData = useMemo(function () {
    var data = prismicData === null || prismicData === void 0 ? void 0 : prismicData.data;
    var body = data === null || data === void 0 ? void 0 : data.slices; // eslint-disable-next-line eqeqeq

    if (body == null) {
      return null;
    }

    return body.map(function (faqSection, idx) {
      if (faqSection.slice_type !== faq_group_slice_type) {
        return null;
      }

      var category = prismicHelpers.asText(faqSection.primary.sectionName);
      var categoryId = faqSection.primary.sectionId;
      var questions = faqSection.items.map(function (item) {
        var itemAnswer = replaceUrlsInPrismicContent(item.answer, getCachedPrismicDomainMapping(config.env, {
          StoreUS: config.baseUsUrl,
          StoreJP: config.baseJpUrl,
          PoplarUS: config.basePoplarUsURL,
          PoplarJP: config.basePoplarJpURL
        }));
        return {
          questionId: item.questionId,
          itemId: item.questionId,
          contentTitle: /*#__PURE__*/_jsx(Title, {
            size: "xs",
            weight: "regular",
            children: /*#__PURE__*/_jsx(PrismicText, {
              field: item.question
            })
          }),
          contentBody: /*#__PURE__*/_jsx(PrismicRichText, {
            field: itemAnswer,
            components: htmlSerializerFaqPage(internalURLs)
          }, "".concat(categoryId, "-").concat(idx))
        };
      });
      return {
        category: category,
        categoryId: categoryId,
        questions: questions
      };
    }).filter(Boolean);
  }, [prismicData === null || prismicData === void 0 ? void 0 : prismicData.data.slices]);
  var getActiveTab = useCallback(function (queryQuestion, querySection) {
    var _initialTabIdx;

    var initialTabIdx = undefined; // Prioritize showing the question over section if both provided.

    if (queryQuestion) {
      initialTabIdx = faqData === null || faqData === void 0 ? void 0 : faqData.reduce(function (prev, curr, idx) {
        if (prev || prev === 0) {
          return prev;
        }

        if ((curr === null || curr === void 0 ? void 0 : curr.questions.findIndex(function (question) {
          return question.questionId === queryQuestion;
        })) !== -1) {
          return idx;
        }

        return prev;
      }, initialTabIdx);
    }

    if (querySection && !(initialTabIdx || initialTabIdx === 0)) {
      var sectionIdx = faqData === null || faqData === void 0 ? void 0 : faqData.findIndex(function (section) {
        return (section === null || section === void 0 ? void 0 : section.categoryId) === querySection;
      });

      if (sectionIdx !== -1) {
        initialTabIdx = sectionIdx;
      }
    }

    return (_initialTabIdx = initialTabIdx) !== null && _initialTabIdx !== void 0 ? _initialTabIdx : 0;
  }, [faqData]);

  var _useState2 = useState(function () {
    return getActiveTab(queryQuestion, querySection);
  }),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  useEffect(function () {
    return setActiveTab(getActiveTab(queryQuestion, querySection));
  }, [queryQuestion, querySection, getActiveTab]);
  var refs = useRef({}); // Scroll to the category during initial load.

  useEffect(function () {
    var isMobile = window.matchMedia("(max-width: ".concat(breakpoints.md - 1, "px)")).matches;
    var tabId = "".concat(isMobile ? '' : 'desktop-').concat(activeTab);
    var categoryHeader = document.querySelector("[data-idx=\"".concat(tabId, "\"]"));

    if (categoryHeader && (queryQuestion || querySection) && activeTab) {
      // Adding a short delay before scrolling to wait for the banner to
      // be rendered. A better fix will be to server render the banner.
      setTimeout(function () {
        var _refs$current;

        if ((_refs$current = refs.current) !== null && _refs$current !== void 0 && _refs$current[queryQuestion]) {
          var element = refs.current[queryQuestion];

          if (element !== null) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }, SCROLL_DELAY_MS);
    } else {
      window.scrollTo({
        top: 0
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  var categories = faqData ? faqData.map(function (d) {
    return d === null || d === void 0 ? void 0 : d.category;
  }) : [];

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, helpers) {
      var reCaptchaToken;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              errorDisplay.clear();
              _context.prev = 1;
              _context.next = 4;
              return reCaptcha.execute(ACTION_FAQ_QUESTION_FORM_SUBMISSION);

            case 4:
              reCaptchaToken = _context.sent;
              _context.next = 7;
              return fetchJson(API_FAQ_QUESTION_FORM_SUBMISSION, {
                method: HTTPMethod.POST,
                body: JSON.stringify(_objectSpread(_objectSpread({}, values), {}, {
                  locale: i18n.language,
                  reCaptchaToken: reCaptchaToken
                }))
              });

            case 7:
              setSuccess(true);
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              errorDisplay.set({
                title: t('common:error.title'),
                message: t('common:error.description')
              });
              throw _context.t0;

            case 14:
              _context.prev = 14;
              helpers.setSubmitting(false);
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10, 14, 17]]);
    }));

    return function handleSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(PageWrapper, {
    children: [/*#__PURE__*/_jsx(SEO, {
      description: t('faq:page-description')
    }), /*#__PURE__*/_jsxs(ContainerGrid, {
      children: [/*#__PURE__*/_jsxs(HeroTextArea, {
        children: [/*#__PURE__*/_jsx(Label, {
          size: "md",
          children: t('faq:hero.label')
        }), /*#__PURE__*/_jsx(Box, {
          mt: 14,
          children: /*#__PURE__*/_jsx(Title, {
            size: {
              _: 'xl',
              lg: 'xxl'
            },
            children: t('faq:hero.title')
          })
        }), /*#__PURE__*/_jsx(HeroTextBox, {
          mt: "normal2",
          children: /*#__PURE__*/_jsx(Text, {
            size: "xl",
            weight: "regular",
            variant: "muted",
            children: t('faq:hero.subtitle')
          })
        })]
      }), /*#__PURE__*/_jsx(HeroImageArea, {
        children: /*#__PURE__*/_jsx(HeroImageRatio, {
          children: /*#__PURE__*/_jsx(Image, {
            src: HeroImage,
            width: 392,
            height: 234,
            priority: true
          })
        })
      })]
    }), /*#__PURE__*/_jsx(FAQLayoutMobile, {
      children: faqData === null || faqData === void 0 ? void 0 : faqData.map(function (faqSection, idx) {
        if (!faqSection) {
          return null;
        }

        var isOpenIdx = faqSection === null || faqSection === void 0 ? void 0 : faqSection.questions.findIndex(function (q) {
          return q.questionId === queryQuestion;
        });
        return /*#__PURE__*/_jsxs(QuestionHolderMobile, {
          "data-testid": IDS.faqSectionMobile,
          children: [/*#__PURE__*/_jsx(Title, {
            size: "sm",
            "data-idx": idx,
            children: faqSection.category
          }), /*#__PURE__*/_jsx(Accordion, {
            data: faqSection.questions,
            id: "".concat(idx, "-faq"),
            isOpenIndex: isOpenIdx,
            refs: refs
          })]
        }, "".concat(faqSection.category, "-mobile"));
      })
    }, "faq-mobile"), /*#__PURE__*/_jsx(FAQLayoutDesktop, {
      mt: 88,
      mb: 72,
      "data-testid": IDS.faqSectionDesktop,
      children: /*#__PURE__*/_jsxs(ContainerGrid, {
        children: [/*#__PURE__*/_jsx(FAQMenu, {
          "data-testid": IDS.faqMenu,
          children: /*#__PURE__*/_jsx(TabVerticalContainer, {
            children: categories.map(function (category, idx) {
              return /*#__PURE__*/_jsx(TabVertical, {
                isActive: idx === activeTab,
                onClick: function onClick() {
                  return setActiveTab(idx);
                },
                children: category
              }, category);
            })
          })
        }), faqData === null || faqData === void 0 ? void 0 : faqData.map(function (data, idx) {
          var _data$questions;

          var isOpenIdx = data === null || data === void 0 ? void 0 : data.questions.findIndex(function (q) {
            return q.questionId === queryQuestion;
          });
          return /*#__PURE__*/_jsxs(QuestionHolder, {
            $isVisible: idx === activeTab,
            children: [/*#__PURE__*/_jsx(Title, {
              size: {
                _: 'sm',
                md: 'md'
              },
              "data-idx": "desktop-".concat(idx),
              children: data === null || data === void 0 ? void 0 : data.category
            }), /*#__PURE__*/_jsx(Accordion, {
              data: (_data$questions = data === null || data === void 0 ? void 0 : data.questions) !== null && _data$questions !== void 0 ? _data$questions : [],
              id: "faq-tab-".concat(idx),
              isOpenIndex: isOpenIdx,
              refs: refs
            })]
          }, "faq-section-".concat(idx));
        })]
      })
    }, "faq-desktop"), /*#__PURE__*/_jsx(CTASection, {
      children: /*#__PURE__*/_jsxs(ContainerGrid, {
        children: [/*#__PURE__*/_jsxs(CTATextSection, {
          children: [/*#__PURE__*/_jsx(Title, {
            children: t('faq:form.cta.title')
          }), /*#__PURE__*/_jsx(Title, {
            as: "p",
            size: {
              _: 'xs',
              md: 'sm'
            },
            weight: "regular",
            children: t('faq:form.cta.description')
          })]
        }), /*#__PURE__*/_jsxs(CTAFormSection, {
          children: [success && /*#__PURE__*/_jsx(SuccessContainerWrapper, {
            children: /*#__PURE__*/_jsxs(SuccessContainer, {
              "data-testid": IDS.success,
              children: [/*#__PURE__*/_jsx(Title, {
                size: "sm",
                children: t('faq:form.success.title')
              }), /*#__PURE__*/_jsx(Text, {
                size: "lg",
                variant: "muted",
                whiteSpace: "pre-wrap",
                children: t('faq:form.success.subtitle')
              })]
            })
          }), /*#__PURE__*/_jsxs(FormContainer, {
            $isVisible: !success,
            children: [showError && /*#__PURE__*/_jsx(Box, {
              mb: "normal2",
              children: /*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
                withBorder: true
              }, errorDisplay), {}, {
                "data-testid": IDS.error
              }))
            }), /*#__PURE__*/_jsx(Formik, {
              initialValues: yoForm.initialState,
              validationSchema: yoForm.schema,
              onSubmit: handleSubmit,
              children: function children(_ref4) {
                var isSubmitting = _ref4.isSubmitting,
                    isValid = _ref4.isValid,
                    dirty = _ref4.dirty;
                return /*#__PURE__*/_jsxs(Form, {
                  "data-testid": IDS.form,
                  children: [/*#__PURE__*/_jsxs(Fieldset, {
                    role: "group",
                    "aria-labelledby": "topic-title",
                    children: [/*#__PURE__*/_jsx(Text, {
                      weight: "bold",
                      size: "xl",
                      id: "topic-title",
                      children: t('faq:form.topic.title')
                    }), /*#__PURE__*/_jsx(Select, {
                      id: "topic",
                      name: "topic",
                      label: t('faq:form.topic.label'),
                      options: options,
                      "data-testid": "faq-topic-select"
                    })]
                  }), /*#__PURE__*/_jsx(Spacer, {
                    size: "normal3"
                  }), /*#__PURE__*/_jsxs(Fieldset, {
                    role: "group",
                    "aria-labelledby": "information-title",
                    children: [/*#__PURE__*/_jsx(Text, {
                      weight: "bold",
                      size: "xl",
                      id: "information-title",
                      children: t('faq:form.information.title')
                    }), /*#__PURE__*/_jsxs(Grid, {
                      gap: "normal2",
                      children: [/*#__PURE__*/_jsxs(NameGrid, {
                        needsPronunciationFields: false,
                        rowGap: "normal2",
                        children: [/*#__PURE__*/_jsx(Input, {
                          id: "givenName",
                          name: "givenName",
                          label: t('common:form.first-name.label')
                        }), /*#__PURE__*/_jsx(Input, {
                          id: "familyName",
                          name: "familyName",
                          label: t('common:form.last-name.label')
                        })]
                      }), /*#__PURE__*/_jsx(Input, {
                        id: "email",
                        name: "email",
                        type: "email",
                        label: t('common:form.email.label')
                      }), /*#__PURE__*/_jsx(Textarea, {
                        id: "description",
                        name: "description",
                        label: t('faq:form.information.how-can-we-help-placeholder')
                      })]
                    })]
                  }), /*#__PURE__*/_jsx(Spacer, {
                    size: "normal3"
                  }), /*#__PURE__*/_jsx(FullWidth, {
                    children: /*#__PURE__*/_jsx(Button, {
                      size: "lg",
                      type: "submit",
                      "data-testid": IDS.submit,
                      isLoading: isSubmitting,
                      isDisabled: !(dirty && isValid) || success,
                      children: t('common:submit')
                    })
                  })]
                });
              }
            })]
          })]
        })]
      })
    })]
  });
};

var FullWidth = styled.div.withConfig({
  componentId: "sc-1elobrt-0"
})(["display:grid;"]);
var CTASection = styled.div.withConfig({
  componentId: "sc-1elobrt-1"
})(["background-color:", ";width:100%;padding-top:", ";margin-bottom:-", ";padding-bottom:", ";", ""], th.getColor('sky'), th.getSpace('large1'), th.getSpace('small3'), th.getSpace('large1'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n     padding-bottom: calc(", " + ", ");\n     margin-bottom: -", ";\n  "])), th.getSpace('large2'), th.getSpace('large3'), th.getSpace('xl2')));
var CTATextSection = styled.div.withConfig({
  componentId: "sc-1elobrt-2"
})(["align-content:center;grid-column:1/5;display:grid;grid-gap:", ";", " ", ""], th.getSpace('normal2'), media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-column: 1/5;\n  "]))), media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-column: 1/6;\n  "]))));
var CTAFormSection = styled.div.withConfig({
  componentId: "sc-1elobrt-3"
})(["position:relative;display:grid;grid-column:1/5;", " ", ""], media.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    grid-column: 5/9;\n  "]))), media.lg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-column: 7/12;\n  "]))));
var FormContainer = styled.div.withConfig({
  componentId: "sc-1elobrt-4"
})(["visibility:", ";background-color:", ";border-radius:", ";padding:", " ", " ", ";margin-top:", ";", ""], function (_ref5) {
  var $isVisible = _ref5.$isVisible;
  return $isVisible ? 'visible' : 'hidden';
}, th.getColor('base000'), th.getRadii('medium'), th.getSpace('normal4'), th.getSpace('normal2'), th.getSpace('normal4'), th.getSpace('normal4'), media.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin-top: unset;\n    padding: ", " ", " ", ";\n  "])), th.getSpace('medium1'), th.getSpace('normal4'), th.getSpace('normal4')));
var SuccessContainerWrapper = styled.div.withConfig({
  componentId: "sc-1elobrt-5"
})(["position:absolute;inset:0;display:grid;align-items:center;"]);
var SuccessContainer = styled.div.withConfig({
  componentId: "sc-1elobrt-6"
})(["background-color:", ";border-radius:", ";padding:", " ", ";", ";display:grid;grid-gap:", ";"], th.getColor('base000'), th.getRadii('medium'), th.getSpace('normal2'), th.getSpace('normal2'), th.getSpace('normal3'), th.getSpace('small3'));
var HeroTextBox = styled(Box).withConfig({
  componentId: "sc-1elobrt-7"
})(["&&{width:", "%;}"], 5 / 6 * 100);
var ContainerGrid = styled(Container).withConfig({
  componentId: "sc-1elobrt-8"
})(["&&{", ";}"], gridBase);
var PageWrapper = styled.div.withConfig({
  componentId: "sc-1elobrt-9"
})(["padding-top:", ";", ""], pxToRem(144), media.lg(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    padding-top: ", ";\n  "])), pxToRem(200)));
var HeroTextArea = styled.div.withConfig({
  componentId: "sc-1elobrt-10"
})(["grid-column:1/5;", " ", ""], media.md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    grid-column: 1/5;\n  "]))), media.lg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    grid-column: 2/8;\n  "]))));
var HeroImageArea = styled.div.withConfig({
  componentId: "sc-1elobrt-11"
})(["position:relative;grid-column:1/5;display:grid;place-items:center center;margin-top:", ";", " ", ""], pxToRem(48), media.md(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    margin-top: unset;\n    grid-column: 5/9;\n  "]))), media.lg(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    grid-column: 8/12;\n  "]))));
var HERO_IMAGE_RATIO = 392 / 234;
var HeroImageRatio = styled.div.withConfig({
  componentId: "sc-1elobrt-12"
})(["width:", ";aspect-ratio:", ";", ""], pxToRem(234), HERO_IMAGE_RATIO, media.md(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    width: 100%;\n  "]))));
var FAQLayoutMobile = styled.div.withConfig({
  componentId: "sc-1elobrt-13"
})(["&&{display:block;margin-top:", ";padding-bottom:", ";background-color:", ";", "}"], pxToRem(60), pxToRem(72), th.getColor('base000'), media.md(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      display: none;\n    "]))));
var FAQLayoutDesktop = styled(Box).withConfig({
  componentId: "sc-1elobrt-14"
})(["&&{display:none;", "}"], media.md(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      display: block;\n    "]))));
var FAQMenu = styled.div.withConfig({
  componentId: "sc-1elobrt-15"
})(["grid-column:1/3;", ""], media.lg(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    grid-column: 2/4;\n  "]))));
var QuestionHolder = styled.div.withConfig({
  componentId: "sc-1elobrt-16"
})(["display:grid;grid-gap:", ";padding:", " ", ";grid-column:3/9;background-color:", ";border-radius:", ";", " ", ""], th.getSpace('normal2'), pxToRem(40), pxToRem(72), th.getColor('base000'), th.getRadii('medium'), function (_ref6) {
  var $isVisible = _ref6.$isVisible;
  return !$isVisible && css(["display:none;"]);
}, media.lg(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n    grid-column: 5/12;\n  "])), pxToRem(64), pxToRem(104)));
var QuestionHolderMobile = styled.div.withConfig({
  componentId: "sc-1elobrt-17"
})(["padding:", " ", " 0;"], pxToRem(56), pxToRem(24));
var Fieldset = styled.div.withConfig({
  componentId: "sc-1elobrt-18"
})(["display:grid;row-gap:", ";"], fieldSetRowGapWidth);
Faq.layout = {
  type: 'marketing',
  props: {
    bgColor: 'base050'
  }
};
export default _withSuperJSONPage(withPageTitle(Faq)({
  translationKey: 'page-title',
  translationNS: 'faq'
}));